import React, { useEffect, useState } from 'react';
import { Card, Typography, Space, Result } from 'antd';
import { GiftOutlined } from '@ant-design/icons';
import { useSearchParams } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const Reveal: React.FC = () => {
    const [searchParams] = useSearchParams();
    const [receiverName, setReceiverName] = useState<string>('');
    const [error, setError] = useState<boolean>(false);
    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const encodedText = searchParams.get('text');
        if (encodedText) {
            try {
                const decoded = decodeURIComponent(escape(atob(encodedText)));
                setReceiverName(decoded);
            } catch (e) {
                setError(true);
            }
        } else {
            setError(true);
        }
    }, [searchParams]);

    if (error) {
        return (
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                padding: '20px'
            }}>
                <Card style={{ maxWidth: 500, width: '100%' }}>
                    <Result
                        status="error"
                        title="Link non valido"
                        subTitle="Il link che hai ricevuto non è valido o è corrotto. Contatta l'organizzatore del sorteggio."
                    />
                </Card>
            </div>
        );
    }

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #d32f2f 0%, #c62828 100%)',
            padding: '20px'
        }}>
            <Card
                style={{
                    maxWidth: 600,
                    width: '100%',
                    borderRadius: '20px',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                    border: '3px solid #b71c1c'
                }}
                bodyStyle={{ padding: isMobile ? '30px 20px' : '50px 40px' }}
            >
                <Space direction="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
                    <div style={{
                        display: 'inline-block',
                        padding: '20px',
                        borderRadius: '50%',
                        border: '4px solid #d32f2f',
                        background: 'white',
                        marginBottom: '12px'
                    }}>
                        <GiftOutlined style={{
                            fontSize: isMobile ? '56px' : '72px',
                            color: '#d32f2f'
                        }} />
                    </div>

                    <Title level={isMobile ? 3 : 2} style={{ color: '#d32f2f', marginBottom: '8px' }}>
                        🎅 Babbo Natale Segreto
                    </Title>

                    <Paragraph style={{ fontSize: isMobile ? '15px' : '17px', color: '#666', marginBottom: '24px' }}>
                        Ecco a chi dovrai fare il regalo! 🎁
                    </Paragraph>

                    <div style={{
                        background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
                        padding: isMobile ? '24px' : '32px',
                        borderRadius: '16px',
                        border: '3px solid #f57c00',
                        marginBottom: '16px'
                    }}>
                        <Paragraph style={{
                            fontSize: '14px',
                            color: '#999',
                            marginBottom: '8px',
                            textTransform: 'uppercase',
                            letterSpacing: '1px',
                            fontWeight: 600
                        }}>
                            Dovrai fare un regalo a:
                        </Paragraph>
                        <Title level={isMobile ? 3 : 2} style={{
                            color: '#f57c00',
                            marginBottom: 0,
                            wordBreak: 'break-word',
                            fontSize: isMobile ? '24px' : '36px'
                        }}>
                            {receiverName}
                        </Title>
                    </div>

                    <div style={{
                        background: '#f5f5f5',
                        padding: '20px',
                        borderRadius: '12px',
                        marginTop: '16px'
                    }}>
                        <Paragraph style={{ fontSize: '13px', color: '#666', marginBottom: '8px' }}>
                            <strong>🤫 Ricorda:</strong>
                        </Paragraph>
                        <ul style={{
                            textAlign: 'left',
                            paddingLeft: '20px',
                            fontSize: '13px',
                            color: '#666',
                            margin: 0
                        }}>
                            <li>Non dire a nessuno a chi devi fare il regalo</li>
                            <li>Non cercare di scoprire chi farà il regalo a te</li>
                            <li>Divertiti a scegliere il regalo perfetto! 🎁</li>
                        </ul>
                    </div>

                    <Paragraph style={{ fontSize: '12px', color: '#999', marginTop: '16px', marginBottom: 0 }}>
                        © 2025 babbonatalesegreto.icu
                    </Paragraph>
                </Space>
            </Card>
        </div>
    );
};

export default Reveal;
